import React, { Component } from 'react';

import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';

import CheckPasswordQuery from './CheckPassword.gql';

import Button from 'components/ui-components/button';
import Input from 'components/ui-components/input';

import './styles.less';

const WRONG_PASSWORD_ERROR = 'Wrong Password';

const requestCheckPassword = (videoId, password) => {
  const gqlClient = getGraphQLClient();

  return gqlClient
    .query({
      query: CheckPasswordQuery,
      variables: {
        videoId,
        password,
      },
    })
    .then(({ data }) => {
      const { isValid } = data;

      return isValid;
    });
};

export default class PasswordModal extends Component {
  constructor(props) {
    super(props);

    this.onPasswordEnter = this.onPasswordEnter.bind(this);
    this.updatePassword = this.updatePassword.bind(this);

    this.state = {
      error: null,
      password: '',
    };
  }

  render() {
    const inputSeverity = this.state.error != null ? 'error' : '';

    return (
      <div className="video-player-password-modal-container">
        <div className="video-player-password-modal">
          <h4>This video is private</h4>
          <Input
            onChange={this.updatePassword}
            onEnter={this.onPasswordEnter}
            fieldLabel="Enter Password"
            fieldId="password"
            fieldType="password"
            fieldValue={this.state.password}
            inputClass="new-style"
            isRequired={true}
            severity={inputSeverity}
            status={this.state.error}
          />
          <Button
            buttonType="rp-primary-2"
            buttonClass="password-button"
            value="Enter"
            onClicked={this.onPasswordEnter}
          />
        </div>
      </div>
    );
  }

  updatePassword(password) {
    this.setState({ password });
  }

  async onPasswordEnter() {
    try {
      this.setState({ error: null });

      const { videoId } = this.props;
      const { password } = this.state;
      const isVerified = await requestCheckPassword(videoId, password);

      if (!isVerified) {
        return this.setState({ error: WRONG_PASSWORD_ERROR });
      }

      this.props.onPassword(password);
    } catch (err) {
      sentry.logException(err, 'error checking password for video');

      this.setState({ error: WRONG_PASSWORD_ERROR });
    }
  }
}
